import Modal from './modal';

export * from './modal';
export * from './modal-header';
export default Modal;
